import { useRef, useState } from "react";
import { recoverPassword } from "../../api/login";
export const FormRecover = () => {
  const [sent, setSent] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  const input = useRef(null), inFlight = useRef(false);
  const submit = async (event) => {
    event.preventDefault();
    if (inFlight.current) return;
    if (!input.current.value.trim() || !input.current.validity.valid) { setError("Introduce un email válido para recuperar tu acceso."); return; }
    inFlight.current = true; setPending(true); setError("");
    try {
      const response = await recoverPassword({ email: input.current.value.trim() });
      if (response?.error === false) setSent(true);
      else setError("No se ha podido enviar el enlace. Comprueba el email y vuelve a intentarlo.");
    } catch { setError("No se ha podido enviar el enlace. Revisa la conexión y vuelve a intentarlo."); }
    finally { inFlight.current = false; setPending(false); }
  };
  return sent ? <div role="status" className="sa-code-help">Se ha enviado un enlace de restablecimiento al email especificado. Revisa también la carpeta de spam.</div> : <form noValidate onSubmit={submit} aria-busy={pending}>
    <label className="labelLogin" htmlFor="recoverEmail">Email</label><input ref={input} id="recoverEmail" type="email" autoComplete="email" required disabled={pending} />
    {error && <p role="alert">{error}</p>}
    <button className="button-1" disabled={pending}>{pending ? "Enviando enlace…" : "Enviar enlace de recuperación"}</button>
  </form>;
};
